import { Search } from '@mui/icons-material';

import {
  Box,
  Button,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
} from '@mui/material';
import React, { useState } from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';
import { ILegalTransactionRelationshipRealEstate } from '../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipRealEstate/ILegalTransactionRelationshipRealEstate';
import { IPostcode } from '../../../../Interfaces/IPostcode';
import { DraggableMarker } from './DraggableMarker';
import { IPosition } from './IPosition';

type MapSearchValue = Pick<
  ILegalTransactionRelationshipRealEstate,
  | 'Street'
  | 'StreetAditional'
  | 'StreetNr'
  | 'Longitude'
  | 'Latitude'
  | 'City'
  | 'Postcode'
  | 'idPostcode'
>;

interface IProps {
  options?: readonly IPostcode[];
  setMapSearch: (newValue: MapSearchValue) => void;
}

export const MapSearch: React.FC<IProps> = ({ options, setMapSearch }) => {
  const [position, setPosition] = useState<IPosition>({
    lat: 52.7597,
    lng: 13.25391,
  });

  const [street, setStreet] = useState('');
  const [streetNr, setStreetNr] = useState('');
  const [postcode, setPostcode] = useState('');
  const [city, setCity] = useState('');
  const [lat, setLat] = useState(0);
  const [long, setLong] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [reload, setReload] = useState(0);

  const searchByText = (e: React.FormEvent) => {
    e.preventDefault();

    if (searchTerm !== '') {
      fetch(
        `https://nominatim.openstreetmap.org/search?q=${searchTerm}&format=json`,
        {
          headers: {
            'User-Agent': 'DiNoPublic',
          },
        }
      )
        .then(res => res.json())
        .then(res => {
          let localObject = res;

          if (Array.isArray(res) && res.length > 0) {
            localObject = res[0];
          }

          if ('lat' in localObject && 'lon' in localObject) {
            setPosition({ lat: localObject.lat, lng: localObject.lon });
            setReload(reload + 1);
          }
        });
      setSearchTerm('');
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item sm={12}>
        <Button
          sx={{ float: 'right' }}
          variant='contained'
          onClick={() =>
            setMapSearch({
              Street: street,
              StreetAditional: null,
              StreetNr: streetNr,
              Longitude: lat,
              Latitude: long,
              City: city,
              Postcode: postcode,
              idPostcode:
                options?.find(x => x.Postcode === postcode)?.idPostcode || null,
            })
          }
        >
          Übernehmen
        </Button>
      </Grid>

      <Grid item sm={12}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                <b>Straße:</b>
              </TableCell>
              <TableCell>
                <i>{street}</i>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <b>Nr:</b>
              </TableCell>
              <TableCell>
                <i>{streetNr}</i>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <b>Stadt:</b>
              </TableCell>
              <TableCell>
                <i>{postcode}</i>, <i>{city}</i>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>
                <b>Koordinaten:</b>
              </TableCell>
              <TableCell>
                <i>{lat}</i>, <i>{long}</i>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Grid>

      <Grid item xs={12}>
        <form onSubmit={searchByText}>
          <Box sx={{ display: 'flex', mt: 5 }}>
            <TextField
              label='Suchen'
              value={searchTerm}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setSearchTerm(event.target.value)
              }
              fullWidth
              size='small'
            />

            <IconButton type='submit'>
              <Search />
            </IconButton>
          </Box>
        </form>
      </Grid>

      <Grid item xs={12} sm={12}>
        <MapContainer
          key={`MapContainer-${reload}`}
          style={{
            height: 400,
            width: '100%',
            alignContent: 'center',
            alignItems: 'center',
          }}
          center={position}
          zoom={16}
          scrollWheelZoom={false}
        >
          <TileLayer
            attribution='&copy;  DiNo von Holland & Kreußlein | Karteninformationen &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
          />
          <DraggableMarker
            position={position}
            setPosition={setPosition}
            setStreet={setStreet}
            setStreetNr={setStreetNr}
            setPostcode={setPostcode}
            setCity={setCity}
            setLat={setLat}
            setLong={setLong}
          />
        </MapContainer>
      </Grid>
    </Grid>
  );
};
